{
  "(optional)": "(valikuline)",
  "(required)": "(nõutav)"
}